import { useSelector } from 'react-redux';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import EventMore from '../Event/EventMore';
import Map from '../Home/Map';
import { BreadcrumbComponent } from '../Partials/Breadcrumb';

const ExecutiveOffice = () => {
  const dictionary = useSelector((state) => state.dictionaryReducer.dictionary);

  const navigate = useNavigate();
  const location = useLocation();

  return (
    <section className="section">
      <div className="container">
        <div className="row">
          <div className="col-lg-9">
            <div className="breadcrumbs mt-4">
              <div className="breadcrumbs-container">
                <BreadcrumbComponent />
              </div>
            </div>

            <h3 className="main-section__title">{dictionary.executive}</h3>

            <div className="main-tab independence">
              <div className="tabs">
                <div className="tabs-box">
                  <ul className="nav nav-tabs" id="myTab" role="tablist">
                    <li className="nav-item">
                      <a
                        className={
                          location.pathname
                          === '/executive_office/chief_of_staff'
                          || location.pathname === '/executive_office'
                            ? 'nav-link active'
                            : 'nav-link'
                        }
                        href="/executive_office/chief_of_staff"
                        id="power-tab"
                        data-toggle="tab"
                        onClick={(e) => {
                          e.preventDefault();
                          navigate('chief_of_staff');
                        }}
                        role="tab"
                        aria-controls="chief"
                        aria-selected="true"
                      >
                        {dictionary.strcuture_menu_level_6}
                      </a>
                    </li>

                    <li className="nav-item">
                      <a
                        className={
                          location.pathname
                          === '/executive_office/regulations'
                            ? 'nav-link active'
                            : 'nav-link'
                        }
                        href="/executive_office/regulations"
                        id="biography-tab"
                        data-toggle="tab"
                        onClick={(e) => {
                          e.preventDefault();
                          navigate('regulations');
                        }}
                        role="tab"
                        aria-controls="assistants"
                        aria-selected="false"
                      >
                        {dictionary.strcuture_menu_level_10}
                      </a>
                    </li>

                    <li className="nav-item">
                      <a
                        className={
                          location.pathname
                          === '/executive_office/structure'
                            ? 'nav-link active'
                            : 'nav-link'
                        }
                        href="/executive_office/structure"
                        id="biography-tab"
                        data-toggle="tab"
                        onClick={(e) => {
                          e.preventDefault();
                          navigate('structure');
                        }}
                        role="tab"
                        aria-controls="assistants"
                        aria-selected="false"
                      >
                        {dictionary.strcuture_menu_level_11}
                      </a>
                    </li>

                    <li className="nav-item">
                      <a
                        className={
                          location.pathname
                          === '/executive_office/assistants_to_the_president'
                            ? 'nav-link active'
                            : 'nav-link'
                        }
                        href="/executive_office/assistants_to_the_president"
                        id="biography-tab"
                        data-toggle="tab"
                        onClick={(e) => {
                          e.preventDefault();
                          navigate('assistants_to_the_president');
                        }}
                        role="tab"
                        aria-controls="assistants"
                        aria-selected="false"
                      >
                        {dictionary.strcuture_menu_level_7}
                      </a>
                    </li>

                    <li className="nav-item">
                      <a
                        className={
                          location.pathname === '/executive_office/press_service'
                            ? 'nav-link active'
                            : 'nav-link'
                        }
                        href="/executive_office/press_service"
                        id="biography-tab"
                        data-toggle="tab"
                        onClick={(e) => {
                          e.preventDefault();
                          navigate('press_service');
                        }}
                        role="tab"
                        aria-controls="press"
                        aria-selected="false"
                      >
                        {dictionary.strcuture_menu_level_9}
                      </a>
                    </li>
                  </ul>

                  <div className="tabs-arrow">
                    <svg
                      width="15"
                      height="8"
                      viewBox="0 0 15 8"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M14 1L7.5 7L1 1"
                        stroke="#3B6B3B"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                </div>
                <div className="tab-content" id="myTabContent">
                  <Outlet />
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-3 pl-lg-4 d-none mt-5 d-lg-block">
            <div className="saidbar">
              <div className="saidbar-content">
                <EventMore />
              </div>
            </div>
          </div>
          <Map />
        </div>
      </div>
    </section>
  );
};

export default ExecutiveOffice;
